import React from 'react';
import {Map} from 'immutable';
import {withMeta, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {
  ADD_TO_CART_ERRORS,
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_ADD_TO_CART_ERROR,
} from '@packages/systems/commerce/constants';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';
import {
  getArrayOrElse,
  getInPojo,
  getNumberOrElse,
  getRecordOrElse,
  getString,
} from '@packages/utilities/data-utils';

const CommerceAddToCartErrorMsg = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const errorsByID = getArrayOrElse(getInPojo(data, ['texts']), [])
      .map((it: unknown) => getRecordOrElse(it, {}))
      .reduce<Record<string, unknown>>((acc, text) => {
        const textId = getString(text.id);
        if (textId) {
          acc[textId] = {copy: text.copy};
        }
        return acc;
      }, {});
    const idx = getNumberOrElse(getInPojo(data, ['temp', 'index']), 0);
    const copy = getString(getInPojo(data, ['texts', idx, 'copy']));

    const newAttributes = attributes.merge(
      Map({
        [DATA_ATTR_NODE_TYPE]: NODE_TYPE_ADD_TO_CART_ERROR,
      })
    );

    const errorsAttr = {
      'data-w-add-to-cart-quantity-error': getString(
        getInPojo(errorsByID, [ADD_TO_CART_ERRORS.QUANTITY.id, 'copy'])
      ),
      'data-w-add-to-cart-general-error': getString(
        getInPojo(errorsByID, [ADD_TO_CART_ERRORS.GENERAL.id, 'copy'])
      ),
      'data-w-add-to-cart-mixed-cart-error': getString(
        getInPojo(errorsByID, [ADD_TO_CART_ERRORS.MIXED_CART.id, 'copy'])
      ),
      'data-w-add-to-cart-buy-now-error': getString(
        getInPojo(errorsByID, [ADD_TO_CART_ERRORS.BUY_NOW.id, 'copy'])
      ),
      'data-w-add-to-cart-checkout-disabled-error': getString(
        getInPojo(errorsByID, [ADD_TO_CART_ERRORS.CHECKOUT_DISABLED.id, 'copy'])
      ),
      'data-w-add-to-cart-select-all-options-error': getString(
        getInPojo(errorsByID, [
          ADD_TO_CART_ERRORS.SELECT_ALL_OPTIONS.id,
          'copy',
        ])
      ),
    } as const;

    return (
      <div {...generateAttributes(newAttributes, classes)} {...errorsAttr}>
        {copy}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Error Message',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: false,
  render: CommerceAddToCartErrorMsg,
  dataType: withMeta(
    {
      textStates: ADD_TO_CART_ERRORS,
      legacyStatePath: ['commerce'],
    },
    createIntegratedRootAliasInstance(
      qualify(Plugins.name('Commerce'), typeName('MultiTextEditAlias'))
    )
  ),
});

export default config;
